var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.791667,
    y: 0.791667,
    width: 55.75,
    height: 52.5833,
    rx: 26.2917,
    stroke: "#EAEAEA",
    strokeWidth: 1.58333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.5833C16 17.1634 16.1668 16.7607 16.4637 16.4637C16.7607 16.1668 17.1634 16 17.5833 16H39.75C40.1699 16 40.5727 16.1668 40.8696 16.4637C41.1665 16.7607 41.3333 17.1634 41.3333 17.5833C41.3333 18.0033 41.1665 18.406 40.8696 18.7029C40.5727 18.9999 40.1699 19.1667 39.75 19.1667H17.5833C17.1634 19.1667 16.7607 18.9999 16.4637 18.7029C16.1668 18.406 16 18.0033 16 17.5833ZM16 27.0833C16 26.6634 16.1668 26.2607 16.4637 25.9637C16.7607 25.6668 17.1634 25.5 17.5833 25.5H39.75C40.1699 25.5 40.5727 25.6668 40.8696 25.9637C41.1665 26.2607 41.3333 26.6634 41.3333 27.0833C41.3333 27.5033 41.1665 27.906 40.8696 28.2029C40.5727 28.4999 40.1699 28.6667 39.75 28.6667H17.5833C17.1634 28.6667 16.7607 28.4999 16.4637 28.2029C16.1668 27.906 16 27.5033 16 27.0833ZM17.5833 35C17.1634 35 16.7607 35.1668 16.4637 35.4637C16.1668 35.7607 16 36.1634 16 36.5833C16 37.0033 16.1668 37.406 16.4637 37.7029C16.7607 37.9999 17.1634 38.1667 17.5833 38.1667H39.75C40.1699 38.1667 40.5727 37.9999 40.8696 37.7029C41.1665 37.406 41.3333 37.0033 41.3333 36.5833C41.3333 36.1634 41.1665 35.7607 40.8696 35.4637C40.5727 35.1668 40.1699 35 39.75 35H17.5833Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.50d722f300ba66fa692373669f3876d1.svg";
export { ForwardRef as ReactComponent };